import { useTranslation } from 'react-i18next';
import { SystemErrorScreen } from '@/entities/system/ui';
import SystemMaintenanceIcon from '@/shared/assets/system-maintenance-icon.svg?react';

export const SystemMaintenanceScreen = () => {
  const { t } = useTranslation();

  const translationKey = 'system.health.maintenance';

  return (
    <SystemErrorScreen
      title={t(`${translationKey}.title`)}
      description={t(`${translationKey}.description`)}
      icon={SystemMaintenanceIcon}
    />
  );
};
